import React from 'react';
const LoanConsultants = () => <div className="service-page"><h1>Loan Consultants</h1><p>Expert loan consultants to guide your financial decisions.</p></div>;
export default LoanConsultants;
